import api from '../token';

export const SolicitarContacto = async (payload) => {
  try {
    const response = await api.post('/requestContacto',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

